"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = /android/i.test(window.navigator.userAgent);


//////////////////
// WEBPACK FOOTER
// ./~/@guazi-fe/components/build/client/utils/isAndroid.js
// module id = 1452
// module chunks = 1